export default {
  HELP_LINKS: 'helpLinks',
}
